import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '';
const API_URL = `${API_BASE}/metrics`;

// Obtener token de localStorage o sessionStorage
const getAuthHeaders = () => {
    const token = localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token');
    return {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    };
};

// KPIs principales
export const getKPISummary = async () => {
    const response = await axios.get(`${API_URL}/kpi-summary`, getAuthHeaders());
    return response.data;
};

// Uso comparativo de módulos
export const getModuleUsage = async () => {
    const response = await axios.get(`${API_URL}/module-usage`, getAuthHeaders());
    return response.data;
};

// Tendencias temporales
export const getModuleTrends = async (days = 30) => {
    const response = await axios.get(`${API_URL}/module-trends?days=${days}`, getAuthHeaders());
    return response.data;
};

// Top usuarios
export const getTopUsers = async (limit = 10) => {
    const response = await axios.get(`${API_URL}/top-users?limit=${limit}`, getAuthHeaders());
    return response.data;
};

// Actividad reciente
export const getRecentActivity = async (limit = 20) => {
    const response = await axios.get(`${API_URL}/recent-activity?limit=${limit}`, getAuthHeaders());
    return response.data;
};

// Detalles de módulo específico
export const getModuleDetails = async (moduleName) => {
    const response = await axios.get(`${API_URL}/module-details/${moduleName}`, getAuthHeaders());
    return response.data;
};
